// import { useSelector } from "react-redux";
// import styled from "styled-components";

// import MiniTruckSvg from "../../../icons/topGarages/MiniTruckSvg";
// import MiniForkSvg from "../../../icons/topGarages/MiniForkSvg";

// const Container = styled.div`
//   width: 80%;
//   margin-right: 20px;

//   .wrapper{
//     width: 100%;
//     display: flex;
//     flex-direction: column;
//     align-items: flex-start !important;
//     gap: 10px;
//     color: ${({theme}) => theme.mainTextColor};
//     .garaj-main-container{
//       width: 100%;
//       display: flex;
//       justify-content: space-between;
//       align-items: center;
//       gap: 10px;
//       padding: 15px 10px;
//       border: 1px solid ${({theme}) => theme.mainBorderColor};
//       border-radius: 15px;
//       overflow: auto;
//       &::-webkit-scrollbar {
//           width: 0;
//           width: 8px;
//           height: 5px;
//       }
//       &::-webkit-scrollbar-thumb {
//           background-color: ${({theme})=> theme.scrollThumbColor};
//           border-radius: 10px;
//       }
//       &::-webkit-scrollbar-track {
//           background-color: transparent;
//       }
//     }
//   }
// `;

// const GarageItem = styled.div`
//   display: flex;
//   align-items: center;

//   .garage-name{
//     font-size: var(--font-size-sm);
//     font-weight: var(--font-weight-xl);
//     margin-right: 5px;
//     color: ${({theme}) => theme.mainTextColor};
    
//   }

//   .garage-stats-wrapper{
//     display: flex;
//     align-items: center;
//     gap: 5px;

//     .garage-stats-item{
//       display: flex;
//       align-items: center;
//       gap: 5px;

//       .garage-stats-quantity{
//         font-size: var(--font-size-sm);
//         font-weight: var(--font-weight-lg);
//       }

//       .green{
//         color: #51A55E;
//       }
//       .yellow{
//         color: #EBB00E;
//       }
//       .red{
//         color: #CC1B1B;
//       }
//     }
//   }

//   .seperator{
//     font-weight: var(--font-weight-xl);
//     padding-left: 10px;
//   }
// `

// const TopbarGaraj = ({ }) => {
//   const { garajYogunlukList } = useSelector((state) => state.admin);

//   const {theme} = useSelector(state => state.layout)

//   return (
//     <Container>
//       <div className="wrapper">
//         <div className="garaj-main-container">
//           {
//             garajYogunlukList.map((item, i) => (
//               <GarageItem>
//                 <div className="garage-name">{item.branchName}</div>
//                 <div className="garage-stats-wrapper">
//                   <div className="garage-stats-item">
//                     <MiniTruckSvg color={theme === "dark" ? "#fff" : "#000"}/>
//                     {/* <MiniTruckSvg color={item.vehicleDensity <= 30 ? "#51A55E" : (item.vehicleDensity > 30 && item.vehicleDensity <= 60) ? "#EBB00E" : "#CC1B1B" }/> */}
//                     <span className={item.vehicleDensity <= 30 ? "green garage-stats-quantity" : (item.vehicleDensity > 30 && item.vehicleDensity <= 60) ? "yellow garage-stats-quantity" : "red garage-stats-quantity" }>%{item.vehicleDensity}</span>
//                   </div>
//                   <div className="garage-stats-item">
//                     <MiniForkSvg color={theme === "dark" ? "#fff" : "#000"}/>
//                     {/* <MiniForkSvg color={item.loadDensity <= 30 ? "#CC1B1B" : (item.loadDensity > 30 && item.loadDensity <= 60) ? "#EBB00E" : "#51A55E" }/> */}
//                     <span className={item.loadDensity <= 30 ? "red garage-stats-quantity" : (item.loadDensity > 30 && item.loadDensity <= 60) ? "yellow garage-stats-quantity" : "green garage-stats-quantity" }>%{item.loadDensity}</span>
//                   </div>
//                 </div>
//                 {
//                   i+1 !== garajYogunlukList.length &&
//                   <span className="seperator">|</span>
//                 }
//               </GarageItem>
//             ))
//           }
//         </div>
//       </div>
//     </Container>
//   );
// };

// export default TopbarGaraj;

import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";

import MiniTruckSvg from "../../../icons/topGarages/MiniTruckSvg";
import MiniForkSvg from "../../../icons/topGarages/MiniForkSvg";

const Container = styled.div`
  width: 80%;
  margin-right: 20px;

  .wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start !important;
    gap: 10px;
    color: ${({ theme }) => theme.mainTextColor};

    .garaj-main-container {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 10px;
      padding: 15px 10px;
      border: 1px solid ${({ theme }) => theme.mainBorderColor};
      border-radius: 15px;
      overflow: hidden;
      white-space: nowrap;
      cursor: grab;
      user-select: none;

      &:active {
        cursor: grabbing;
      }
    }
  }
`;

const GarageItem = styled.div`
  display: inline-flex;
  align-items: center;

  .garage-name {
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-xl);
    margin-right: 5px;
    color: ${({ theme }) => theme.mainTextColor};
  }

  .garage-stats-wrapper {
    display: flex;
    align-items: center;
    gap: 5px;

    .garage-stats-item {
      display: flex;
      align-items: center;
      gap: 5px;

      .garage-stats-quantity {
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
      }

      .green {
        color: #51A55E;
      }
      .yellow {
        color: #EBB00E;
      }
      .red {
        color: #CC1B1B;
      }
    }
  }

  .seperator {
    font-weight: var(--font-weight-xl);
    padding-left: 10px;
  }
`;

const TopbarGaraj = ({ }) => {
  const { garajYogunlukList } = useSelector((state) => state.admin);
  const { theme } = useSelector(state => state.layout);
  const containerRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);



  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - containerRef.current.offsetLeft);
    setScrollLeft(containerRef.current.scrollLeft);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - containerRef.current.offsetLeft;
    const walk = (x - startX) * 2; 
    containerRef.current.scrollLeft = scrollLeft - walk;
  };


  return (
    <Container>
      <div className="wrapper">
        <div 
          className="garaj-main-container"
          ref={containerRef}
          onMouseDown={handleMouseDown}
          onMouseLeave={handleMouseLeave}
          onMouseUp={handleMouseUp}
          onMouseMove={handleMouseMove}
        >
          {garajYogunlukList.map((item, i) => (
            <GarageItem key={i}>
              <div className="garage-name">{item.branchName}</div>
              <div className="garage-stats-wrapper">
                <div className="garage-stats-item">
                  <MiniTruckSvg color={theme === "dark" ? "#fff" : "#000"} />
                  <span className={item.vehicleDensity <= 30 ? "green garage-stats-quantity" : (item.vehicleDensity > 30 && item.vehicleDensity <= 60) ? "yellow garage-stats-quantity" : "red garage-stats-quantity"}>%{item.vehicleDensity}</span>
                </div>
                <div className="garage-stats-item">
                  <MiniForkSvg color={theme === "dark" ? "#fff" : "#000"} />
                  <span className={item.loadDensity <= 30 ? "red garage-stats-quantity" : (item.loadDensity > 30 && item.loadDensity <= 60) ? "yellow garage-stats-quantity" : "green garage-stats-quantity"}>%{item.loadDensity}</span>
                </div>
              </div>
              {i + 1 !== garajYogunlukList.length && <span className="seperator">|</span>}
            </GarageItem>
          ))}
        </div>
      </div>
    </Container>
  );
};

export default TopbarGaraj;
